'use client';
var classes = {"root":"m-347db0ec","root--dot":"m-fbd81e3d","label":"m-5add502a","section":"m-91fdda9b"};

export default classes;
//# sourceMappingURL=Badge.module.mjs.map
